import MovieCard from '@/components/base/MovieCard';
import type { Movie } from '@/types/movie';

interface PopularSectionProps {
  movies: Movie[];
}

export default function PopularSection({ movies }: PopularSectionProps) {
  return (
    <section className="border-t border-background-300/40 bg-background-100">
      <div className="mx-auto w-full px-4 py-14 md:px-8 md:py-20">
        <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
          <div>
            <p className="font-display text-sm tracking-[0.25em] text-primary-400">TRENDING</p>
            <h2 className="mt-1 text-2xl text-foreground-950 md:text-3xl">本月热门午夜影片</h2>
            <p className="mt-2 text-sm text-foreground-500">按本月观看量与收藏数综合排序</p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4 md:grid-cols-3 md:gap-6 lg:grid-cols-4">
          {movies.map((movie) => (
            <MovieCard key={movie.id} movie={movie} showTags />
          ))}
        </div>
      </div>
    </section>
  );
}